import { render, staticRenderFns } from "./SelectIdCard.vue?vue&type=template&id=bf4eff5c&"
import script from "./SelectIdCard.vue?vue&type=script&lang=js&"
export * from "./SelectIdCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports